export default "__VITE_ASSET__CDF1dXAI__"